import { createContext, useState, useCallback, useMemo } from "react"

export const AppContext = createContext()

const useAppContext = () => {
  const [user, setUser] = useState(() =>
    JSON.parse(sessionStorage.getItem("user")),
  )

  const [userToken, setUserToken] = useState(() =>sessionStorage.getItem("userToken"))

  const loggedInUserFeatures = useMemo(
    () => user?.featureDTOList,
    [user?.featureDTOList],
  )
  const loggedInUser = useMemo(() => user?.userBasicDTO, [user?.userBasicDTO])
  const loggedInOffice = useMemo(
    () => user?.officeBasicDTO,
    [user?.officeBasicDTO],
  )

  const onAuthSuccess = useCallback((data,token) => {
    setUser(data)
    setUserToken(token)
  }, [setUserToken])

  const onAuthReset = useCallback(() => {
    sessionStorage.clear(), []
    setUser(null)
    setUserToken(null)
  }, [setUserToken])

  return {
    user,
    userToken,
    loggedInUserFeatures,
    loggedInUser,
    loggedInOffice,
    onAuthSuccess,
    onAuthReset,
  }
}

export const AppContextProvider = ({ children }) => {
  const {
    user,
    userToken,
    loggedInOffice,
    loggedInUserFeatures,
    loggedInUser,
    onAuthSuccess,
    onAuthReset,
  } = useAppContext()
  return (
    <AppContext.Provider
      value={{
        user,
        userToken,
        loggedInOffice,
        loggedInUserFeatures,
        loggedInUser,
        onAuthSuccess,
        onAuthReset,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
